export const DEFAULT_CURRENCY = 'VND';